import type { Middleware } from '@reduxjs/toolkit';
import { mapToolChanged } from '~/store/frontendState/leftSidebar/leftSidebar.actionCreators';

export const openedMapToolChangeMiddleware: Middleware = store => next => action => {
  const previousTool = store.getState().frontendState.leftSidebar.openedMapTool;
  const result = next(action);
  const currentTool = store.getState().frontendState.leftSidebar.openedMapTool;

  if (currentTool !== previousTool) {
    store.dispatch(mapToolChanged(currentTool, previousTool));
  }

  return result;
};
